import React from 'react'

import { alianzasData } from '../data/data'

export default function Alianzas() {
    return (
        <>
            <div className="row justify-content-center">
                {alianzasData.map((item, index) => {
                    return (
                        <div className="col-lg-2 col-md-6 col-6 mt-4 pt-2" key={index}>
                            <div className="alianzas position-relative overflow-hidden rounded p-3 mx-auto">
                                <div className="position-relative">
                                    <div className="alianzas-image position-relative overflow-hidden text-center py-0 my-0">
                                        <img src={item.image} className="img-fluid py-0 my-0" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </>
    )
}
